import { FC } from 'react';
import styles from '@app/common/PageHeader/HeaderBar/index.module.less';
import Link from '@base/lib/ThemeLink';
import { RouteEnum } from 'pro/config/routers';
import { generatePath } from 'ava-util/dist/request';
import HeaderBarDropdown, { HeaderBarMenuProps } from '@app/common/PageHeader/HeaderBarDropdown';
import { useTrans } from 'base/utils/i18n';

const supportList = [
    {
        text: 'web_help_contact_us',
        href: generatePath(RouteEnum.HELP, { code: 'contact-us' })
    },
    {
        text: 'web_shop_brand_story',
        href: generatePath(RouteEnum.BRAND_STORY )
    },
    {
        text: 'web_help_return_policy',
        href: generatePath(RouteEnum.HELP, { code: 'return-policy' })
    },
];

const Menu: FC<HeaderBarMenuProps> = ({ onClose }) => {
    const { t } = useTrans();
    return (
        <div className={styles['widget-links']}>
            {supportList.map(item => (
                <Link key={item.text} href={item.href}>
                    <a onClick={onClose}>
                        {t(item.text)}
                    </a>
                </Link>
            ))}
        </div>
    )
};

const HeaderSupport: FC = () => {
    const { t } = useTrans();
    return (
        <HeaderBarDropdown
            triggerProps={{ content: t('web_help_title_support') }}
            menu={<Menu/>}
            placement="bottom"
        />
    )
};

export default HeaderSupport;
